import { Fragment } from 'react'
import clsx from 'clsx'
import styles from './HighlightText.module.css'
import { splitHighlight } from 'lib/highlight'

interface HighlightTextProps {
  /** The text to render. */
  text: string
  /** Query / name whose match gets emphasised inside `text`. Null/empty → plain text. */
  query: string | null | undefined
  /**
   * Match the whole query as one exact phrase (product-name mentions) instead of
   * per-word (typeahead). Exact avoids bleeding into a neighbouring name.
   */
  exact?: boolean
  /** Extra class on each highlight span, for per-call theming. */
  highlightClassName?: string
}

/**
 * Wrap query matches in `text` with a styled `<span>`. Drop-in: to stop
 * highlighting a spot, replace `<HighlightText text={x} query={y} />` with `{x}`.
 */
const HighlightText: React.VFC<HighlightTextProps> = ({
  text,
  query,
  exact,
  highlightClassName,
}) => {
  const segments = splitHighlight(text, query, { exact })
  return (
    <>
      {segments.map((seg, i) => {
        if (!seg.match) {
          return <Fragment key={i}>{seg.text}</Fragment>
        }
        return (
          <span key={i} className={clsx(styles.highlight, highlightClassName)}>
            {seg.text}
          </span>
        )
      })}
    </>
  )
}

export default HighlightText
